import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=4f9d78cf&"
import script from "./ClientProfile.vue?vue&type=script&lang=js&"
export * from "./ClientProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfile.vue?vue&type=style&index=0&id=4f9d78cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports